import * as Sentry from "@sentry/react";

console.log(import.meta.env.VITE_SENTRY_ENV);
Sentry.init({
  dsn:
    "https://9284a8cb926cb8b85aa7b265a43f9cc4@o4509052939665408.ingest.us.sentry.io/4509052954148864",
  environment: import.meta.env.VITE_SENTRY_ENV,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0
});
